module.exports = __webpack_public_path__ + "img/sch4-info.4f72bfdd.png";